import arrayUtilities from "./arrayUtilities";
import colorUtilities from "./colorUtilities";
import stringUtilities from "./stringUtilities";

export default {

    getType(workflowId, typeName, workflows, hasHueOrColor) {

        if (stringUtilities.isNullOrEmpty(typeName) || arrayUtilities.isNullOrEmpty(workflows)) {
            return "";
        }

        let type = null;

        let workflow = workflows.find(x => x.id === workflowId);

        if (workflow && !stringUtilities.isNullOrEmpty(workflow.configuration)) {

            try {
                let found = false;

                var configuration = JSON.parse(workflow.configuration);
                for (let t = 0; t < configuration.types.length; t++) {
                    if (configuration.types[t].name === typeName && (!hasHueOrColor || (!stringUtilities.isNullOrEmpty(configuration.types[t].hue) || !stringUtilities.isNullOrEmpty(configuration.types[t].color)))) {
                        type = JSON.parse(JSON.stringify(configuration.types[t]));
                        type.name = workflow.Text + " - " + type.name;
                        found = true;
                    }
                }

                if (!found && configuration.types2 && configuration.types2 !== null && configuration.types2.length > 0) {
                    for (let t = 0; t < configuration.types2.length; t++) {
                        if (configuration.types2[t].name === typeName && (!hasHueOrColor || (!stringUtilities.isNullOrEmpty(configuration.types2[t].hue) || !stringUtilities.isNullOrEmpty(configuration.types2[t].color)))) {
                            type = configuration.types2[t];
                            type = JSON.parse(JSON.stringify(configuration.types2[t]));
                            type.name = workflow.Text + " - " + type.name;
                        }
                    }
                }
            }
            catch (e) {

            }
        }

        return type;
    },

    getIsDashedFromPoint(point, workflows) {
        let typeName = point.formData?.Type;
        
        let type = this.getType(point.workflowId, typeName, workflows, false);

        return type !== null && type.isDashed;
    },

    hasCpm(point) {
        return !isNaN(parseFloat(point?.formData?.CPM));
    },

    getCpm(point) {
        const cpm = parseFloat(point?.formData?.CPM);
        if (isNaN(cpm)) {
            return 0;
        }

        return cpm;
    },

    getColorFromPoint(point, workflows) {

        const formDataColor = this.getColorFromFormData(point.formData);
        if (formDataColor !== null) {
            return formDataColor;
        }

        return this.getColorFromWorkflowAndType(point.workflowId, point.formData?.Type, workflows);
    },

    getColorFromFormData(formData) {
        if (!formData) {
            return null;
        }

        if (!stringUtilities.isNullOrEmpty(formData.Colour)) {
            return stringUtilities.ensureStringHasPrefix(formData.Colour, "#");
        }

        const cutFill = parseFloat(formData.CutFill);
        if (!isNaN(cutFill)) {
            if (cutFill > 0.1) {
                return "#ff0000";
            }
            return "#00ff00";
        }

        const conductivity = parseFloat(formData.Conductivity);
        if (!isNaN(conductivity)) {
            return colorUtilities.hueToHex(this.getHueForConductivity(conductivity));
        }

        const colourCode = parseInt(formData.ColourCode);
        if (!isNaN(colourCode)) {
            return colorUtilities.hueToHex(colourCode);
        }

        const cpm = parseFloat(formData.CPM);
        const high = parseFloat(formData.HighLevel);
        const low = parseFloat(formData.LowLevel);
        if (!isNaN(cpm) && !isNaN(high) && !isNaN(low)) {
            return colorUtilities.hueToHex(this.getHueForCpm(cpm, high, low));
        }

        return null;
    },

    getHueForConductivity(conductivity) {
        if (conductivity <= 90) {
            return 240;
        }
        if (conductivity <= 140) {
            return 120;
        }
        if (conductivity <= 170) {
            return 60;
        }
        if (conductivity <= 200) {
            return 30;
        }
        if (conductivity <= 500) {
            return 0;
        }
        return 270;
    },

    getHueForCpm(cpm, high, low) {
        if (cpm >= high) {
            return 0;
        }
        if (cpm <= low) {
            return 120;
        }
        return 60;
    },

    getColorFromWorkflowAndType(workflowId, typeName, workflows) {

        if (!stringUtilities.isNullOrEmpty(workflowId) && !stringUtilities.isNullOrEmpty(typeName) && !arrayUtilities.isNullOrEmpty(workflows)) {
            let type = this.getType(workflowId, typeName, workflows, true);

            if (type !== null && !stringUtilities.isNullOrEmpty(type.color)) {
                return stringUtilities.ensureStringHasPrefix(type.color, "#");
            } else if (type !== null && type.hue && type.hue !== undefined) {
                return colorUtilities.hueToHex(type.hue);
            } else {
                if (!stringUtilities.isNullOrEmpty(workflowId)) {
                    let workflow = workflows.find(x => x.id === workflowId);
                    if (workflow && workflow !== null) {
                        if (!stringUtilities.isNullOrEmpty(workflow.color)) {
                            return stringUtilities.ensureStringHasPrefix(workflow.color, "#");
                        } else if (workflow.hue && workflow.hue !== undefined) {
                            return colorUtilities.hueToHex(workflow.hue);
                        }
                    }
                }
            }
        }

        return "#f00"; //TODO: define the default colour
    },

    getBaseSlugForIcons() {
        return `https://terraflow.blob.core.windows.net/icons/`;
    },

    getIconUrlFromPoint(point, workflows) {
        return this.getIconUrlFromWorkflowAndType(point.workflowId, point.formData?.Type, workflows);
    },

    getIconUrlFromWorkflowAndType(workflowId, typeName, workflows) {

        try {
            if (!stringUtilities.isNullOrEmpty(workflowId) && !arrayUtilities.isNullOrEmpty(workflows)) {

                let iconUrl = "";

                let workflow = workflows.find(x => x.id === workflowId);

                if (workflow && !stringUtilities.isNullOrEmpty(workflow.configuration)) {
                    var configuration = JSON.parse(workflow.configuration);

                    if (workflowId.toLowerCase() === workflow.id.toLowerCase()) {
                        for (let t = 0; t < configuration.types.length; t++) {

                            if (configuration.types[t].name === typeName && !stringUtilities.isNullOrEmpty(configuration.types[t].iconUrl)) {
                                iconUrl = configuration.types[t].iconUrl;
                            }
                        }

                        if (stringUtilities.isNullOrEmpty(iconUrl) && configuration.types2 && configuration.types2 !== null && configuration.types2.length > 0) {
                            for (let t = 0; t < configuration.types2.length; t++) {
                                if (configuration.types2[t].name === typeName && !stringUtilities.isNullOrEmpty(configuration.types2[t].iconUrl)) {
                                    iconUrl = configuration.types2[t].iconUrl;
                                }
                            }
                        }
                    }
                }

                if (!stringUtilities.isNullOrEmpty(iconUrl)) {
                    return `${this.getBaseSlugForIcons()}${iconUrl}`;
                }
            }
        }
        catch (e) {

        }

        return "";
    },

    geometryIsLineOrPolygon(geometryType) {
        return geometryType === "Line" || geometryType === "Polygon"
    },

    filterSymbolsByDensity(midPoints, symbolDensity) {

        if (arrayUtilities.isNullOrEmpty(midPoints)) {
            return [];
        }
        
        const n = midPoints.length;
        const filtered = n % 2 === 1
            ? midPoints.filter((_, index) => Math.abs(index - (n - 1) / 2) % symbolDensity === 0)
            : midPoints.filter((_, index, arr) => { const offset = Math.round(((arr.length - 1) % symbolDensity) / 2); return index >= offset && (index - offset) % symbolDensity === 0; });
        return filtered
    }
}